import { UserModel } from '@truckdown/accounts';
import context from '@truckdown/components-systems';
import { Constants } from '@truckdown/systems';

export const messageEventName = 'show-message';

export function showMessage(message: string, messageType: string, dismissable: boolean, autoDismiss: boolean) {
    context.events.emit(messageEventName, {
        message: message,
        messageType: messageType,
        dismissable: dismissable,
        autoDismiss: autoDismiss
    });
}

export function isUserInRole(user: UserModel, role: string) {
    if (user == null) {
        return false;
    }

    let roles = user.roles ?? [];
    let rolesClaims = user.claims.filter(c => c.type == "role").map(claim => claim.value);

    return roles.indexOf(role) > -1 || rolesClaims.indexOf(role) > -1;
}

export function getUserRoles(user: UserModel) {
    let roles = user.roles ?? [];
    let rolesClaims = user.claims.filter(c => c.type == "role").map(claim => claim.value);

    //return roles.concat(rolesClaims);
    return [...new Set([...roles, ...rolesClaims])];
}

export function isCsrOrAdmin() {
    return context.isInRole(Constants.Roles.SystemRole) || context.isInRole(Constants.Roles.CSRRole);
}

export function isFleet() {
    return context.isInRole(Constants.Roles.FleetUserRole);
}

export function isGeneralAdmin() {
    return context.isInRole(Constants.Roles.CustomerAdminRole);
}

export function isSystemAdmin() {
    return context.isInRole(Constants.Roles.SystemRole);
}

export function formatRadius (radius: string) {
    if (radius == "fifty") {
        return "50 Miles";
    } else if (radius == "twentyFive") {
        return "25 Miles";
    } else if (radius == "twenty") {
        return "20 Miles";
    } else if (radius == "fifteen") {
        return "15 Miles";
    } else if (radius == "ten") {
        return "10 Miles";
    } else if (radius == "five") {
        return "5 Miles";
    } else if (radius == "Zero") {
        return "0 Miles";
    } else {
        return "100 Miles";
    }
}
